"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _errorMessage = require("@hookform/error-message");
var _reactHookForm = require("react-hook-form");
var _Modal = _interopRequireDefault(require("../Modal"));
var _DynamicFields = require("./DynamicFields");
var _CustomFields = require("./CustomFields");
var _Box = _interopRequireDefault(require("../../elements/Box"));
var _Message = _interopRequireDefault(require("../Message"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); } /* eslint-disable jsx-a11y/label-has-associated-control */ /* eslint-disable no-nested-ternary */
const Form = _ref => {
  let {
    fields,
    layout,
    action,
    fieldFactory,
    nested,
    renderMode,
    handleClose,
    header,
    portalId,
    parameterPageNotes
  } = _ref;
  const hiddenButtonRef = (0, _react.useRef)(null);
  const [ids, setIds] = (0, _react.useState)();
  const formMethods = (0, _reactHookForm.useForm)({
    mode: 'all'
  });
  const {
    watch,
    handleSubmit,
    // eslint-disable-next-line no-unused-vars
    formState: {
      isSubmitting,
      isValid,
      errors
    }
  } = formMethods;
  const handleDataUpdates = (data, field) => {
    const handledFields = ['Divisions', 'Participants'];
    const handleIds = handler => {
      if (Array.isArray(data)) {
        const allIds = data.map(id => id[handler]);
        setIds({
          ...ids,
          [field.fieldName]: allIds
        });
      }
    };

    // eslint-disable-next-line no-unused-expressions
    handledFields.includes(field.inputType) ? handleIds(field.handler) : setIds({
      ...ids,
      [field.fieldName]: data
    });
  };
  const {
    buttonAction,
    buttonLocation,
    behavior
  } = layout;
  const {
    columns,
    gap,
    align,
    justify
  } = layout.grid;
  const modalRoot = document.getElementById('modal-root');
  const styles = {
    gridContainer: {
      display: 'grid',
      gridTemplateColumns: `repeat(${columns}, 1fr)`,
      gap: `${gap}`,
      alignItems: `${align}`,
      justifyItems: `${justify}`
    }
  };
  const watchedFields = fields.reduce((acc, field) => {
    if (field.watching) {
      const fieldWatchingHandler = ids && ids[field.watching] || watch(field.watching);
      acc[field.fieldName] = {
        ...acc[field.fieldName],
        ...{
          watching: field.watching
        },
        ...{
          expecting: field.expecting
        },
        ...{
          expectType: field.expectType
        },
        ...{
          watchType: field.watchType
        },
        ...{
          handler: field.handler
        },
        ...{
          watch: fieldWatchingHandler
        }
      };
    }
    return acc;
  }, []);

  // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
  function getWatchedFields(key) {
    return fields.reduce((acc, field) => {
      if (field.watching && field.fieldName === key) {
        // eslint-disable-next-line no-param-reassign
        acc = {
          watching: field.watching,
          expecting: field.expecting,
          expectType: field.expectType,
          watchType: field.watchType,
          watch: ids && ids[field.watching] || watch(field.watching)
        };
      }
      return acc;
    }, {});
  }
  const manageFieldVisibility = fieldName => {
    const theField = getWatchedFields(fieldName);
    let regExExpecting = null;
    if (theField.expectType === 'REGEX') {
      regExExpecting = new RegExp(theField.expecting);
    }
    if (Object.keys(watchedFields).includes(fieldName)) {
      var _theField$watch, _theField$watch2;
      if (Array.isArray(theField.watch) && !theField.watch.some(item => item === theField.expecting) || typeof theField.watch === 'boolean' && theField.watch !== theField.expecting || typeof theField.watch === 'object' && (((_theField$watch = theField.watch) === null || _theField$watch === void 0 ? void 0 : _theField$watch.length) === 0 || typeof ((_theField$watch2 = theField.watch) === null || _theField$watch2 === void 0 ? void 0 : _theField$watch2.length) === 'undefined') || (theField.expectType === 'REGEX' ? !regExExpecting.test(theField.watch) : typeof theField.watch === 'string' && theField.watch !== theField.expecting)) return theField.watchType === 'HIDE';
    }
    return true;
  };
  const onSubmit = (allData, error) => {
    Object.assign(allData, ids);
    const filteredData = {};
    Object.entries(allData).forEach(_ref2 => {
      let [key, value] = _ref2;
      if (manageFieldVisibility(key)) {
        filteredData[key] = value;
      }
    });
    action(filteredData, error);
  };
  const renderPortal = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (parameterPageNotes === null || parameterPageNotes === void 0 ? void 0 : parameterPageNotes.length) > 0 && /*#__PURE__*/_react.default.createElement(_Message.default, {
    color: "info",
    showIcon: true,
    size: "normal",
    type: "info",
    backgroundColor: "white"
  }, /*#__PURE__*/_react.default.createElement("div", null, parameterPageNotes.map((note, index) => /*#__PURE__*/_react.default.createElement("div", {
    key: index
  }, note.split('.').map((line, i) => line.length > 1 ? /*#__PURE__*/_react.default.createElement("li", {
    key: i
  }, `${line}.`) : ''))))), /*#__PURE__*/_react.default.createElement(_Box.default, {
    title: header
  }, /*#__PURE__*/_react.default.createElement("form", {
    onSubmit: e => {
      e.stopPropagation();
      handleSubmit(onSubmit)(e);
    },
    className: "form is-clearfix",
    noValidate: true
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gridContainer",
    style: styles.gridContainer
  }, /*#__PURE__*/_react.default.createElement(_reactHookForm.FormProvider, formMethods, fields.map((field, idx) => {
    var _field$original, _field$original2;
    const {
      label,
      ...restOfField
    } = field;
    if (field !== null && field !== void 0 && (_field$original = field.original) !== null && _field$original !== void 0 && _field$original.labelPosition || field !== null && field !== void 0 && (_field$original2 = field.original) !== null && _field$original2 !== void 0 && _field$original2.inputPosition) {
      var _field$original3, _field$original4, _field$original5, _field$original6, _field$original7, _field$original8, _field$original9, _field$original10;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
        key: idx
      }, manageFieldVisibility(field.fieldName) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: "fieldLabelContainer",
        style: {
          gridColumn: field !== null && field !== void 0 && (_field$original3 = field.original) !== null && _field$original3 !== void 0 && (_field$original3 = _field$original3.labelPosition) !== null && _field$original3 !== void 0 && _field$original3.column ? `${field.original.labelPosition.column} / span ${field.original.labelPosition.span || 1}` : null,
          gridRow: field !== null && field !== void 0 && (_field$original4 = field.original) !== null && _field$original4 !== void 0 && (_field$original4 = _field$original4.labelPosition) !== null && _field$original4 !== void 0 && _field$original4.row ? field.original.labelPosition.row : null,
          justifySelf: field !== null && field !== void 0 && (_field$original5 = field.original) !== null && _field$original5 !== void 0 && (_field$original5 = _field$original5.labelPosition) !== null && _field$original5 !== void 0 && _field$original5.justify ? field.original.labelPosition.justify : null,
          alignSelf: field !== null && field !== void 0 && (_field$original6 = field.original) !== null && _field$original6 !== void 0 && (_field$original6 = _field$original6.labelPosition) !== null && _field$original6 !== void 0 && _field$original6.align ? field.original.labelPosition.align : null
        }
      }, /*#__PURE__*/_react.default.createElement("label", {
        className: "label"
      }, field === null || field === void 0 ? void 0 : field.label)), /*#__PURE__*/_react.default.createElement("div", {
        className: "fieldInputContainer",
        style: {
          gridColumn: field !== null && field !== void 0 && (_field$original7 = field.original) !== null && _field$original7 !== void 0 && (_field$original7 = _field$original7.inputPosition) !== null && _field$original7 !== void 0 && _field$original7.column ? `${field.original.inputPosition.column} / span ${field.original.inputPosition.span || 1}` : null,
          gridRow: field !== null && field !== void 0 && (_field$original8 = field.original) !== null && _field$original8 !== void 0 && (_field$original8 = _field$original8.inputPosition) !== null && _field$original8 !== void 0 && _field$original8.row ? field.original.inputPosition.row : null,
          justifySelf: field !== null && field !== void 0 && (_field$original9 = field.original) !== null && _field$original9 !== void 0 && (_field$original9 = _field$original9.inputPosition) !== null && _field$original9 !== void 0 && _field$original9.justify ? field.original.inputPosition.justify : null,
          alignSelf: field !== null && field !== void 0 && (_field$original10 = field.original) !== null && _field$original10 !== void 0 && (_field$original10 = _field$original10.inputPosition) !== null && _field$original10 !== void 0 && _field$original10.align ? field.original.inputPosition.align : null
        }
      }, /*#__PURE__*/_react.default.createElement(_CustomFields.CustomFields, _extends({}, restOfField, {
        fieldFactory: fieldFactory,
        controlError: errors[field.fieldName] && 'is-danger',
        handleDataUpdates: theData => handleDataUpdates(theData, field)
      })), /*#__PURE__*/_react.default.createElement(_DynamicFields.DynamicFields, _extends({}, restOfField, {
        controlError: errors[field.fieldName] && 'is-danger',
        handleDataUpdates: theData => handleDataUpdates(theData, field)
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "has-text-danger"
      }, /*#__PURE__*/_react.default.createElement(_errorMessage.ErrorMessage, {
        errors: errors,
        name: field.fieldName
      })))));
    }
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: idx
    }, manageFieldVisibility(field.fieldName) && /*#__PURE__*/_react.default.createElement("div", {
      className: "fieldContainer",
      style: {
        gridColumn: field.UI.column,
        gridRow: field.UI.row,
        justifySelf: field.UI.justify,
        alignSelf: field.UI.align,
        height: field.UI.height,
        width: field.UI.width
      }
    }, /*#__PURE__*/_react.default.createElement(_CustomFields.CustomFields, _extends({}, field, {
      fieldFactory: fieldFactory,
      controlError: errors[field.fieldName] && 'is-danger',
      handleDataUpdates: theData => handleDataUpdates(theData, field)
    })), /*#__PURE__*/_react.default.createElement(_DynamicFields.DynamicFields, _extends({}, field, {
      controlError: errors[field.fieldName] && 'is-danger',
      handleDataUpdates: theData => handleDataUpdates(theData, field)
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "has-text-danger"
    }, /*#__PURE__*/_react.default.createElement(_errorMessage.ErrorMessage, {
      errors: errors,
      name: field.fieldName
    }))));
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: `has-text-${buttonLocation}  my-4`
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: "button is-primary",
    type: "submit",
    disabled: behavior === 'submit' ? isSubmitting : !isValid
    // onClick={() => hiddenButtonRef.current.click()}
  }, behavior === 'submit' ? isSubmitting ? buttonAction[1] : buttonAction[0] : !isValid ? buttonAction[1] : buttonAction[0])))));
  const renderModal = /*#__PURE__*/_react.default.createElement(_Modal.default, {
    closeModalCallback: handleClose,
    header: header,
    portalContainer: modalRoot,
    fullWidth: true,
    footer: /*#__PURE__*/_react.default.createElement("div", {
      className: `has-text-${buttonLocation}`
    }, /*#__PURE__*/_react.default.createElement("button", {
      className: "button is-primary",
      type: "submit",
      disabled: behavior === 'submit' ? isSubmitting : !isValid,
      onClick: () => hiddenButtonRef.current.click()
    }, behavior === 'submit' ? isSubmitting ? buttonAction[1] : buttonAction[0] : !isValid ? buttonAction[1] : buttonAction[0]))
  }, /*#__PURE__*/_react.default.createElement("form", {
    onSubmit: e => {
      e.stopPropagation();
      handleSubmit(onSubmit)(e);
    },
    className: "form is-clearfix",
    noValidate: true
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gridContainer",
    style: styles.gridContainer
  }, /*#__PURE__*/_react.default.createElement(_reactHookForm.FormProvider, formMethods, fields.map((field, idx) => {
    var _field$original11, _field$original12;
    const {
      label,
      ...restOfField
    } = field;
    if (field !== null && field !== void 0 && (_field$original11 = field.original) !== null && _field$original11 !== void 0 && _field$original11.labelPosition || field !== null && field !== void 0 && (_field$original12 = field.original) !== null && _field$original12 !== void 0 && _field$original12.inputPosition) {
      var _field$original13, _field$original14, _field$original15, _field$original16, _field$original17, _field$original18, _field$original19, _field$original20;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
        key: idx
      }, manageFieldVisibility(field.fieldName) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: "fieldLabelContainer",
        style: {
          gridColumn: field !== null && field !== void 0 && (_field$original13 = field.original) !== null && _field$original13 !== void 0 && (_field$original13 = _field$original13.labelPosition) !== null && _field$original13 !== void 0 && _field$original13.column ? `${field.original.labelPosition.column} / span ${field.original.labelPosition.span || 1}` : null,
          gridRow: field !== null && field !== void 0 && (_field$original14 = field.original) !== null && _field$original14 !== void 0 && (_field$original14 = _field$original14.labelPosition) !== null && _field$original14 !== void 0 && _field$original14.row ? field.original.labelPosition.row : null,
          justifySelf: field !== null && field !== void 0 && (_field$original15 = field.original) !== null && _field$original15 !== void 0 && (_field$original15 = _field$original15.labelPosition) !== null && _field$original15 !== void 0 && _field$original15.justify ? field.original.labelPosition.justify : null,
          alignSelf: field !== null && field !== void 0 && (_field$original16 = field.original) !== null && _field$original16 !== void 0 && (_field$original16 = _field$original16.labelPosition) !== null && _field$original16 !== void 0 && _field$original16.align ? field.original.labelPosition.align : null
        }
      }, /*#__PURE__*/_react.default.createElement("label", {
        className: "label"
      }, /*#__PURE__*/_react.default.createElement("b", null, field === null || field === void 0 ? void 0 : field.label))), /*#__PURE__*/_react.default.createElement("div", {
        className: "fieldInputContainer",
        style: {
          gridColumn: field !== null && field !== void 0 && (_field$original17 = field.original) !== null && _field$original17 !== void 0 && (_field$original17 = _field$original17.inputPosition) !== null && _field$original17 !== void 0 && _field$original17.column ? `${field.original.inputPosition.column} / span ${field.original.inputPosition.span || 1}` : null,
          gridRow: field !== null && field !== void 0 && (_field$original18 = field.original) !== null && _field$original18 !== void 0 && (_field$original18 = _field$original18.inputPosition) !== null && _field$original18 !== void 0 && _field$original18.row ? field.original.inputPosition.row : null,
          justifySelf: field !== null && field !== void 0 && (_field$original19 = field.original) !== null && _field$original19 !== void 0 && (_field$original19 = _field$original19.inputPosition) !== null && _field$original19 !== void 0 && _field$original19.justify ? field.original.inputPosition.justify : null,
          alignSelf: field !== null && field !== void 0 && (_field$original20 = field.original) !== null && _field$original20 !== void 0 && (_field$original20 = _field$original20.inputPosition) !== null && _field$original20 !== void 0 && _field$original20.align ? field.original.inputPosition.align : null
        }
      }, /*#__PURE__*/_react.default.createElement(_CustomFields.CustomFields, _extends({}, restOfField, {
        fieldFactory: fieldFactory,
        controlError: errors[field.fieldName] && 'is-danger',
        handleDataUpdates: theData => handleDataUpdates(theData, field)
      })), /*#__PURE__*/_react.default.createElement(_DynamicFields.DynamicFields, _extends({}, restOfField, {
        controlError: errors[field.fieldName] && 'is-danger',
        handleDataUpdates: theData => handleDataUpdates(theData, field)
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "has-text-danger"
      }, /*#__PURE__*/_react.default.createElement(_errorMessage.ErrorMessage, {
        errors: errors,
        name: field.fieldName
      })))));
    }
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: idx
    }, manageFieldVisibility(field.fieldName) && /*#__PURE__*/_react.default.createElement("div", {
      className: "fieldContainer",
      style: {
        gridColumn: field.UI.column,
        gridRow: field.UI.row,
        justifySelf: field.UI.justify,
        alignSelf: field.UI.align,
        height: field.UI.height,
        width: field.UI.width
      }
    }, /*#__PURE__*/_react.default.createElement(_CustomFields.CustomFields, _extends({}, field, {
      fieldFactory: fieldFactory,
      controlError: errors[field.fieldName] && 'is-danger',
      handleDataUpdates: theData => handleDataUpdates(theData, field)
    })), /*#__PURE__*/_react.default.createElement(_DynamicFields.DynamicFields, _extends({}, field, {
      controlError: errors[field.fieldName] && 'is-danger',
      handleDataUpdates: theData => handleDataUpdates(theData, field)
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "has-text-danger"
    }, /*#__PURE__*/_react.default.createElement(_errorMessage.ErrorMessage, {
      errors: errors,
      name: field.fieldName
    }))));
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: `has-text-${buttonLocation}  my-4`
  }, /*#__PURE__*/_react.default.createElement("button", {
    ref: hiddenButtonRef,
    style: {
      display: 'none'
    }
  }, "Submit"))));
  if (renderMode === 'asPortal' && portalId) {
    const rootElement = document.getElementById(portalId);
    return /*#__PURE__*/_reactDom.default.createPortal(renderPortal, rootElement);
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, renderMode === 'asPortal' && renderPortal, renderMode === 'modal' && renderModal, renderMode === undefined && /*#__PURE__*/_react.default.createElement("form", {
    onSubmit: e => {
      if (nested) {
        e.stopPropagation();
        handleSubmit(onSubmit)(e);
      }
      if (!nested) {
        handleSubmit(onSubmit)(e);
      }
    },
    className: "form is-clearfix",
    noValidate: true
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gridContainer",
    style: styles.gridContainer
  }, /*#__PURE__*/_react.default.createElement(_reactHookForm.FormProvider, formMethods, fields.map((field, idx) => {
    var _field$original21, _field$original22;
    const {
      label,
      ...restOfField
    } = field;
    if (field !== null && field !== void 0 && (_field$original21 = field.original) !== null && _field$original21 !== void 0 && _field$original21.labelPosition || field !== null && field !== void 0 && (_field$original22 = field.original) !== null && _field$original22 !== void 0 && _field$original22.inputPosition) {
      var _field$original23, _field$original24, _field$original25, _field$original26, _field$original27, _field$original28, _field$original29, _field$original30;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
        key: idx
      }, manageFieldVisibility(field.fieldName) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: "fieldLabelContainer",
        style: {
          gridColumn: field !== null && field !== void 0 && (_field$original23 = field.original) !== null && _field$original23 !== void 0 && (_field$original23 = _field$original23.labelPosition) !== null && _field$original23 !== void 0 && _field$original23.column ? `${field.original.labelPosition.column} / span ${field.original.labelPosition.span || 1}` : null,
          gridRow: field !== null && field !== void 0 && (_field$original24 = field.original) !== null && _field$original24 !== void 0 && (_field$original24 = _field$original24.labelPosition) !== null && _field$original24 !== void 0 && _field$original24.row ? field.original.labelPosition.row : null,
          justifySelf: field !== null && field !== void 0 && (_field$original25 = field.original) !== null && _field$original25 !== void 0 && (_field$original25 = _field$original25.labelPosition) !== null && _field$original25 !== void 0 && _field$original25.justify ? field.original.labelPosition.justify : null,
          alignSelf: field !== null && field !== void 0 && (_field$original26 = field.original) !== null && _field$original26 !== void 0 && (_field$original26 = _field$original26.labelPosition) !== null && _field$original26 !== void 0 && _field$original26.align ? field.original.labelPosition.align : null
        }
      }, /*#__PURE__*/_react.default.createElement("label", {
        className: "label"
      }, field === null || field === void 0 ? void 0 : field.label)), /*#__PURE__*/_react.default.createElement("div", {
        className: "fieldInputContainer",
        style: {
          gridColumn: field !== null && field !== void 0 && (_field$original27 = field.original) !== null && _field$original27 !== void 0 && (_field$original27 = _field$original27.inputPosition) !== null && _field$original27 !== void 0 && _field$original27.column ? `${field.original.inputPosition.column} / span ${field.original.inputPosition.span || 1}` : null,
          gridRow: field !== null && field !== void 0 && (_field$original28 = field.original) !== null && _field$original28 !== void 0 && (_field$original28 = _field$original28.inputPosition) !== null && _field$original28 !== void 0 && _field$original28.row ? field.original.inputPosition.row : null,
          justifySelf: field !== null && field !== void 0 && (_field$original29 = field.original) !== null && _field$original29 !== void 0 && (_field$original29 = _field$original29.inputPosition) !== null && _field$original29 !== void 0 && _field$original29.justify ? field.original.inputPosition.justify : null,
          alignSelf: field !== null && field !== void 0 && (_field$original30 = field.original) !== null && _field$original30 !== void 0 && (_field$original30 = _field$original30.inputPosition) !== null && _field$original30 !== void 0 && _field$original30.align ? field.original.inputPosition.align : null
        }
      }, /*#__PURE__*/_react.default.createElement(_CustomFields.CustomFields, _extends({}, restOfField, {
        fieldFactory: fieldFactory,
        controlError: errors[field.fieldName] && 'is-danger',
        handleDataUpdates: theData => handleDataUpdates(theData, field)
      })), /*#__PURE__*/_react.default.createElement(_DynamicFields.DynamicFields, _extends({}, restOfField, {
        controlError: errors[field.fieldName] && 'is-danger',
        handleDataUpdates: theData => handleDataUpdates(theData, field)
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "has-text-danger"
      }, /*#__PURE__*/_react.default.createElement(_errorMessage.ErrorMessage, {
        errors: errors,
        name: field.fieldName
      })))));
    }
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: idx
    }, manageFieldVisibility(field.fieldName) && /*#__PURE__*/_react.default.createElement("div", {
      className: "fieldContainer",
      style: {
        gridColumn: field.UI.column,
        gridRow: field.UI.row,
        justifySelf: field.UI.justify,
        alignSelf: field.UI.align,
        height: field.UI.height,
        width: field.UI.width
      }
    }, /*#__PURE__*/_react.default.createElement(_CustomFields.CustomFields, _extends({}, field, {
      fieldFactory: fieldFactory,
      controlError: errors[field.fieldName] && 'is-danger',
      handleDataUpdates: theData => handleDataUpdates(theData, field)
    })), /*#__PURE__*/_react.default.createElement(_DynamicFields.DynamicFields, _extends({}, field, {
      controlError: errors[field.fieldName] && 'is-danger',
      handleDataUpdates: theData => handleDataUpdates(theData, field)
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "has-text-danger"
    }, /*#__PURE__*/_react.default.createElement(_errorMessage.ErrorMessage, {
      errors: errors,
      name: field.fieldName
    }))));
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: `has-text-${buttonLocation}  my-4`
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: "button is-primary",
    type: "submit",
    disabled: behavior === 'submit' ? isSubmitting : !isValid
  }, behavior === 'submit' ? isSubmitting ? buttonAction[1] : buttonAction[0] : !isValid ? buttonAction[1] : buttonAction[0]))));
};
Form.displayName = 'Form';
Form.propTypes = {
  fields: _propTypes.default.arrayOf(_propTypes.default.shape({
    fieldName: _propTypes.default.string.isRequired,
    inputType: _propTypes.default.string,
    label: _propTypes.default.string,
    options: _propTypes.default.arrayOf(_propTypes.default.shape({
      label: _propTypes.default.string,
      value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
      id: _propTypes.default.string,
      name: _propTypes.default.string,
      anchor: _propTypes.default.bool
    })),
    defaultValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool, _propTypes.default.array, _propTypes.default.shape({
      label: _propTypes.default.string,
      value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
      id: _propTypes.default.string,
      name: _propTypes.default.string,
      anchor: _propTypes.default.bool
    })]),
    config: _propTypes.default.object,
    UI: _propTypes.default.shape({
      column: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
      row: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
      align: _propTypes.default.string,
      justify: _propTypes.default.string
    }),
    original: _propTypes.default.object
  })),
  layout: _propTypes.default.shape({
    buttonAction: _propTypes.default.array.isRequired,
    buttonLocation: _propTypes.default.string,
    behavior: _propTypes.default.string,
    grid: _propTypes.default.shape({
      columns: _propTypes.default.string.isRequired,
      gap: _propTypes.default.string,
      align: _propTypes.default.string,
      justify: _propTypes.default.string
    })
  }),
  action: _propTypes.default.func.isRequired,
  fieldFactory: _propTypes.default.func,
  nested: _propTypes.default.bool,
  portalId: _propTypes.default.any,
  parameterPageNotes: _propTypes.default.any
};
var _default = exports.default = Form;
//# sourceMappingURL=Form.js.map